import {Button, Divider, Stack, capitalize} from '@mui/material';
import React from 'react';

import {StyledCard} from 'presentation/components';
import Icon from 'presentation/icons';
import {translations} from 'presentation/translations-new';

import {useOdontoDuplicityBookedCard} from './hooks/useOdontoDuplicityBookedCard';
import {OdontoDuplicityBookedCardProps} from './types';

const {at, showDetails} = translations['pt-br'].commons;

export function OdontoDuplicityBookedCard({scheduledBooking}: OdontoDuplicityBookedCardProps) {
	const {handleGoToDetails, CONTENT_LIST, color, variant, iconName} =
		useOdontoDuplicityBookedCard({
			scheduledBooking,
		});

	return (
		<StyledCard.Container
			$borderTop
			$borderColor={color}
			elevation={1}
			sx={{maxWidth: 402, width: '100%'}}>
			<StyledCard.Header
				iconProps={{
					variant,
					customIconName: iconName,
				}}
				title={capitalize(scheduledBooking.formattedDateWithWeekday || '')}
				subtitle={`${at} ${scheduledBooking.hour}`}
			/>
			<Divider />

			<StyledCard.Content list={CONTENT_LIST} sx={{flexDirection: 'column'}} />

			<Stack alignItems={'end'}>
				<Button
					variant="text"
					endIcon={<Icon name="arrow-right" />}
					onClick={handleGoToDetails}>
					{showDetails}
				</Button>
			</Stack>
		</StyledCard.Container>
	);
}
